export const DsfUserImportPanel = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_import" */ "./userImport/userImport.vue")
);

const ctrls = {
  DsfUserImportPanel
};

const install = dsf.createDsfVueInstall("platform", ctrls);

export { install };
export default install;
